import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject, ViewChild, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LGEDataService } from 'src/commons';
import { ConfirmModalComponent } from 'src/commons/modals';

@Component({
    selector: 'acc-dist-modal',
    templateUrl: './acc-dist-details.component.html',
    styleUrls: ['./acc-dist-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccDistDetailsComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() message: string;
    @Input() accDistData: any;


    public confirm: any;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    displayedColumns = ['select', 'code', 'description'];
    dataSource: MatTableDataSource<any>;

    selection = new SelectionModel<any>(true, []);

    selectedAccDistData: any[] = [];

    constructor(
        private _dataService: LGEDataService,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<AccDistDetailsComponent>,
        private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) private data: any) {
        this.message = data.message;
        this.title = data.title;
        this.accDistData = data.accDistData;
    }

    ngOnInit() {
        this.createForms();
        setTimeout(() => {
            this.dataSource = new MatTableDataSource(this.accDistData);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        });
        // console.log("nginit", this.accDistData, this.dataSource);
        this.selectedAccDistData = this.accDistData.filter((account) => account.isActive);
    }

    isAllSelected() {
        const numSelected = this.selectedAccDistData.length;
        const numRows = this.dataSource && this.dataSource.data.length;
        // // console.log(numSelected === numRows)
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle(event) {
        // console.log(event, this.dataSource.data);

        this.dataSource.data.forEach(row => row.isActive = event.checked);
        this.selectedAccDistData = event.checked ? this.dataSource.data.map(obj => ({ ...obj })) : [];
        // console.log( this.selectedAccDistData,  this.dataSource);
    }
    projectChecked(row) {
        // this.selection.toggle(row);

        if (this.selectedAccDistData.find(account => row.accDistInfoId === account.accDistInfoId) && !row.isActive) {
            const index = this.selectedAccDistData.findIndex(account => row.accDistInfoId === account.accDistInfoId);
            this.selectedAccDistData.splice(index, 1);
        } else {
            this.selectedAccDistData.push(row);
        }
        // // console.log(row);
        // // console.log(this.selectedAccDistData);
    }

    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    private createForms(): void {

    }

    public showConfirm(title: string, message: string) {
        this.confirm = this.dialog.open(ConfirmModalComponent, {
            width: '350px',
            disableClose: false,
            data: { title: title, message: message }
        });
    }

    onSave() {
        this.showConfirm('Are you sure you want to save?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.dialogRef.close(this.selectedAccDistData);
            }
        });
    }

    onCancel() {
        this.dialogRef.close();
    }

    ngOnDestroy() {

    }
}
